import { DOCUMENT, inject, Injectable } from '@angular/core'

@Injectable()
export class DownloadService {
  private readonly document = inject(DOCUMENT)

  downloadFile(filename: string, content: string | Blob, mimeType = 'text/plain') {
    let blob: Blob
    if (typeof content === 'string') {
      // Convert string content to Blob
      blob = new Blob([content], { type: mimeType })
    } else {
      blob = content
    }
    const url = URL.createObjectURL(blob)

    const link = this.document.createElement('a')
    link.href = url
    link.target = '_blank' // Open in new tab
    link.download = filename

    this.document.body.appendChild(link) // Required for Firefox
    link.click()
    this.document.body.removeChild(link)

    // Erst spaeter freigeben: Edge liest die Blob-URL nicht unbedingt im Klick selbst. Fragt er
    // nach dem Speicherort oder prueft SmartScreen die Datei, war sie bei sofortiger Freigabe schon
    // weg, und der Download endete mit „Netzwerkfehler".
    setTimeout(() => URL.revokeObjectURL(url), 60_000)
  }

  downloadQrCode(filename: string, content: string) {
    this.qrCode(content).then((qr) => {
      this.downloadDataUrl(filename, qr)
    })
  }

  /** `qrcode` wird erst beim Aufruf geladen: der Dienst haengt am Start der App, die Bibliothek nicht. */
  async qrCode(content: string): Promise<string> {
    const { default: QRCode } = await import('qrcode')
    return QRCode.toDataURL(content)
  }

  downloadDataUrl(filename: string, dataUrl: string) {
    const link = this.document.createElement('a')
    link.href = dataUrl
    link.target = '_blank' // Open in new tab
    link.download = filename

    this.document.body.appendChild(link) // Required for Firefox
    link.click()
    this.document.body.removeChild(link)
  }
}
